<template>
  <div class="storeExamineResult" v-if="result>0">
    <div class="top" v-if="result==1">
      <img src="../assets/image/storeExamineResult/success.png" alt />
      <h6>初步审核通过</h6>
    </div>
    <div class="top" v-if="result==2">
      <img src="../assets/image/storeExamineResult/fail.png" alt />
      <h6>审核失败</h6>
      <p>您的资质证照不符合要求</p>
    </div>
    <div class="bottom" v-if="result==1">
      <h6>联系我们</h6>
      <img src="../assets/image/storeSpreadPage/icon_wechat_code.jpg" alt />
      <button class="btn" data-clipboard-text="19146458110">复制微信号</button>
      <p>联系电话：191-4645-8110</p>
      <p>周一 至 周六 9:00 至 21:00</p>
    </div>
  </div>
</template>
<script>
import ClipboardJS from "clipboard";
export default {
  name: "storeExamineResult",
  data() {
    return {
      result: 0,
    };
  },
  mounted() {
    var self = this;
    if (self.$route.query.type == "success") {
      self.result = 1;
    } else if (self.$route.query.type == "fail") {
      self.result = 2;
    }

    var clipboard = new ClipboardJS(".btn");
    clipboard.on("success", function (e) {
      self.$alert({
        text: "复制成功",
      });
      e.clearSelection();
    });
  },
};
</script>
<style lang="scss" scoped>
@import url("../assets/style/rem.css");
.storeExamineResult {
  .top {
    text-align: center;
    overflow: hidden;
    img {
      width: 2.3rem;
      height: 2.3rem;
      margin: 1.14rem auto 0.3rem;
    }
    h6 {
      color: #000000;
      font-size: 0.4rem;
    }

    p {
      color: #666666;
      font-size: 0.28rem;
      margin-top: 0.1rem;
    }
  }

  .bottom {
    text-align: center;
    border-top: 0.1rem solid #f8f8f8;
    margin-top: 0.5rem;
    overflow: hidden;

    h6 {
      color: #333333;
      font-size: 0.3rem;
      padding: 0.6rem 0 0.18rem;
    }

    img {
      width: 2rem;
      height: 2rem;
      box-shadow: 0px 0px 0.06rem 0px rgba(0, 0, 0, 0.18);
      border-radius: 0.05rem;
    }

    button {
      width: 1.6rem;
      height: 0.6rem;
      background: #ffffff;
      box-shadow: 0px 0px 0.04rem 0px rgba(0, 0, 0, 0.2);
      border-radius: 0.3rem;
      line-height: 0.6rem;
      color: #897af2;
      font-size: 0.26rem;
      display: block;
      cursor: pointer;
      margin: 0.24rem auto 0.28rem;
    }

    p {
      color: #666666;
      font-size: 0.28rem;
    }
  }
}
</style>